// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__gqp18","makeOpaque":"Toast_makeOpaque__lk7b2"};